<template>
  <mdb-container>
    <div class="gp-has-header">
      <div v-if="settings && settings.features.quickLogin" class="text-left">
        <translate-section v-if="translationMode" category="page" sub-category="quickConnect" />

        <mdb-card>
          <mdb-card-header>
            <h4>{{ $t("page.quickConnect.title") }}
              <translate-modal v-if="translationMode" category="page" sub-category="quickConnect" name="title"/>
            </h4>
          </mdb-card-header>
          <mdb-card-body v-if="!$route.params.code">
            <div v-if="!emailSubmitted">
              <div v-if="!isStandalone" class="text-info">{{ $t("page.quickConnect.intro") }}
                <translate-modal v-if="translationMode " category="page" sub-category="quickConnect" name="intro"/>
              </div>
              <div v-if="isStandalone" class="text-info">{{ $t("page.quickConnect.introCode") }}
                <translate-modal v-if="translationMode " category="page" sub-category="quickConnect" name="introCode"/>
              </div>
              <mdb-input id="email-input" type="text" v-model="email" :placeholder="$tc('common.label.emailAddress',1)" required
                         :label="$tc('common.label.emailAddress',1)">
                <translate-modal v-if="translationMode" category="common" sub-category="label" name="emailAddress"/>
              </mdb-input>

              <mdb-btn @click="submitEmail" icon="check">{{ $t("common.button.go") }}</mdb-btn>
              <translate-modal v-if="translationMode" category="common" sub-category="button" name="go"/>
              <div>
                <router-link to="/">{{ $t("page.quickConnect.other") }}</router-link>
                <translate-modal v-if="translationMode" category="page" sub-category="quickConnect" name="other"/>
              </div>
            </div>
            <div v-if="emailSubmitted && !isStandalone">
              {{ $t("page.quickConnect.confirmationMessage", {fromEmail: settings.connectEmail}) }}
            </div>
            <div v-if="emailSubmitted && isStandalone">
              {{ $t("page.quickConnect.confirmationMessageCode", {fromEmail: settings.connectEmail}) }}
              <mdb-input id="code-input" type="text" v-model="linkCode" placeholder="Enter Code" required
                         label="Code">
              </mdb-input>
              <div v-html="tokenMessage" class="text-danger"></div>
              <mdb-btn @click="validateCode" icon="check">{{ $t("common.button.go") }}</mdb-btn>
              <mdb-btn v-if="tokenMessage != ''" color="danger" @click="startOver" icon="recycle">{{ $t("page.quickConnect.generateNewCode") }}</mdb-btn>


            </div>
          </mdb-card-body>
          <mdb-card-body v-if="$route.params.code">
            <div v-html="tokenMessage"></div>
            <div v-if="!tokenValid">
              <mdb-btn @click="startOver" icon="recycle">{{ $t("page.quickConnect.generateNewLink") }}</mdb-btn>
            </div>
          </mdb-card-body>
        </mdb-card>
      </div>

    </div>
  </mdb-container>
</template>

<script>
import {mapState} from 'vuex'
import api from "../services/groupsPlaceApi";
import timezone from "../services/timezone";
import VueRecaptcha from "vue-recaptcha";
import translateModal from "./common/TranslateModal";
import translateSection from "./common/TranslateSection";

import {
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardFooter,
  mdbCardHeader,
  mdbContainer,
  mdbInput,
  mdbMask,
  mdbModal,
  mdbModalBody,
  mdbModalFooter,
  mdbModalHeader,
  mdbSpinner,
  mdbView
} from 'mdbvue';
import Vue from "vue";

export default {
  name: 'quick-connect',
  components: {
    mdbInput,
    mdbBtn,
    mdbCard,
    mdbCardBody,
    mdbCardHeader,
    mdbCardFooter,
    mdbSpinner,
    mdbMask,
    mdbView,
    mdbModal,
    mdbModalBody,
    mdbModalHeader,
    mdbModalFooter,
    mdbContainer,
    VueRecaptcha,
    translateModal,
    translateSection
  },
  computed: mapState({
                       apiKey: state => state.apiKey,
                       userDetails: state => state.userDetails,
                       loggedIn: state => state.loggedIn,
                       settings: state => state.settings,
                       translationMode: state => state.translationMode
                     }),
  data() {
    return {
      checkingToken: false,
      tokenValid: false,
      tokenMessage: "",
      emailSubmitted: false,
      email: "",
      recaptcha: "",
      isStandalone: false,
      linkCode: ""
    }
  },
  mounted() {
    this.isStandalone = api.isStandalone()
    document.title = "Quick Connect"
    if (this.loggedIn && !this.translationMode) {
      if (this.$route.query.event) this.$router.push("/event/show/" + this.$route.query.event)
      if (this.$route.query.group) this.$router.push("/group/" + this.$route.query.group)
      else this.$router.push("/")
      return
    }
    if (this.$route.query.email) {
      this.email = this.$route.query.email
      this.submitEmail()
    }
    if (this.$route.params.code) {
      this.$store.dispatch("setExecuting", true)
      let affiliateCode = localStorage.getItem("affiliate")
      api.post("/user/validateQuickConnect", {
        code: this.$route.params.code, affiliateCode: affiliateCode,
        timezone: timezone.detectTimeZone()
      }).then(
        (details) => {
          this.tokenMessage = this.$t("page.quickConnect.linkValidated")
          if (details.data.results && details.data.results.rsvpComplete) {  //get them right to the event!
            localStorage.setItem("redirectOnLogin", "/event/show/" + details.data.results.event)
          }
          api.trackEvent("email-login-success", details.data.results)
          api.completeLogin(details.data.authKey, details.data.secret, details.data.isNewUser)
        },
        (error) => {
          this.tokenValid = false
          if (error.response.status == 404) this.tokenMessage = this.$t("page.quickConnect.linkInvalid")
          else this.tokenMessage = error.response.data
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    }
  },
  methods: {
    gotRecaptcha: function (recap) {
      this.recaptcha = recap
    },
    expiredRecaptcha: function () {
      this.recaptcha = null
    },
    startOver() {
      if (!this.isStandalone) this.$router.replace("/quick-connect")
      this.tokenValid = false
      this.emailSubmitted = false
    },
    submitEmail() {
      if (!this.isStandalone) this.tokenMessage = this.$t("page.quickConnect.checkingLink")
      let el = document.getElementById("email-input")
      if (!this.email) {
        if (el) {
          el.classList.add("invalid")
          el.classList.add("is-invalid")
        }
        return
      }

      if (el) {
        el.classList.remove("invalid")
        el.classList.remove("is-invalid")
      }

      api.trackEvent("email-login-submitted", { email: this.email })

      this.$store.dispatch("setExecuting", true)

      let payload = {email: this.email, recaptcha: this.recaptcha, isStandalone: this.isStandalone}
      if (this.$route.query.event) payload.event = this.$route.query.event
      if (this.$route.query.group) payload.group = this.$route.query.group

      api.post("/user/quickConnect", payload).then(
        (details) => {
          this.emailSubmitted = true
          if (this.isStandalone) {
            Vue.nextTick().then(() => {
              let el = document.getElementById("code-input")
              if (el) {
                el.focus()
              }
            })
          }
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 10000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    validateCode() {
      this.$store.dispatch("setExecuting", true)
      this.tokenMessage = ""
      let affiliateCode = localStorage.getItem("affiliate")
      api.post("/user/validateQuickConnect", {
        code: this.linkCode, affiliateCode: affiliateCode,
        timezone: timezone.detectTimeZone()
      }).then(
        (details) => {
          this.tokenMessage = this.$t("page.quickConnect.linkValidated")
          if (details.data.results && details.data.results.rsvpComplete) {  //get them right to the event!
            localStorage.setItem("redirectOnLogin", "/event/show/" + details.data.results.event)
          }
          api.completeLogin(details.data.authKey, details.data.secret, details.data.isNewUser)
        },
        (error) => {
          this.tokenValid = false
          if (error.response.status == 404) this.tokenMessage = this.$t("page.quickConnect.linkInvalid")
          else this.tokenMessage = error.response.data
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    }
  }
}
</script>

